import type { Voucher, VoucherListByHotelId_TopPageQuery } from "@/lib/gql/__generated__/graphql";

type Props = {
	data: VoucherListByHotelId_TopPageQuery | undefined;
};

export const useVoucherTopQuery = ({ data }: Props) => {
	// 販売中のVoucher
	const sellingVouchers: Voucher[] = data
		? data.voucherListByHotelID.voucherList
				.filter((voucher) => voucher.inSale)
				.map((item) => {
					const { __typename, ...voucher } = item;

					return { ...voucher } satisfies Voucher;
				})
		: [];

	// 売り止め中のVoucher
	const stopSellingVouchers: Voucher[] = data
		? data.voucherListByHotelID.voucherList
				.filter((voucher) => !voucher.inSale)
				.map((item) => {
					const { __typename, ...voucher } = item;

					return { ...voucher } satisfies Voucher;
				})
		: [];

	return {
		sellingVouchers,
		stopSellingVouchers,
	};
};
